export const SERVICE = 'BACKOFFICE_TEMPLATES'
